<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card style="overflow-y:hidden; height:78vh;">
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Gestion des rubriques
            </strong>
          </div>
          <b-row>
            <b-col sm="12">
              <button type="button" @click="createRubrique()" class="btn btn-success  pull-right"><i class="fa fa-plus"></i> Créer une nouvelle rubrique</button>
            </b-col>
          </b-row>
          <h5>Liste des rubriques</h5>
          <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-scroll-y="scrollHandle">
            <div v-if="isEmpty(rubriques)">Aucune rubrique n'est créée pour l'instant</div>
            <SlickList v-else lockAxis="y" v-model="rubriques" class="list-group" :useDragHandle="true" @input="sorted()">
              <div v-for="(rubrique, index) in rubriques" :key="index">
                <handleSlickItem  :index="index"  :item="rubrique"  groupKey="rubrique" action="supprimer" :id="`item-${rubrique.id}`" role="tab" class="block-rubrique" :style="getStyle(rubrique)">
                  {{ rubrique.libelle }} <i v-if="canManage()" class="fa fa-trash pull-right text-danger" @click="removeRubrique(rubrique.id)"></i>
                </handleSlickItem>
                <b-collapse :id="`collapse-${rubrique.id}`" class="" :accordion="`accordion-rubrique`" role="tabpanel" :visible=visible>
                  <b-card class="mb-0">
                    <p :id="`infosRubrique-${rubrique.id}`" class="card-text">
                      <b-row class="my-1">
                        <b-col sm="12">
                          <i v-if="canManage()" class="fa fa-pencil pull-right clickable" @click="editRubrique(rubrique)"></i>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label for="libelle">Libellé :</label>
                        </b-col>
                        <b-col sm="4">
                          <b-form-input id="libelle" :value="rubrique.libelle" size="sm" placeholder="Entrer le nom de la rubrique" :class="{hasError: errors.libelle !== ''}" disabled></b-form-input>
                          <span class='field-error'>{{ errors.libelle }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label for="categorie">Catégorie :</label>
                        </b-col>
                        <b-col sm="4">
                          <b-form-select
                            :id="`categorieSelect-${rubrique.id}`"
                            :plain="true"
                            :options="categoryOptions"
                            :value="rubrique.categorie_id"
                            :class="{hasError: errors.categorie_id !== ''}"
                            disabled>
                            <template #first>
                              <b-form-select-option :value="null">--- Sélectionnez une catégorie ---</b-form-select-option>
                            </template>
                          </b-form-select>
                          <span class='field-error'>{{ errors.categorie_id }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="my-1" v-show="editSousCategory[rubrique.id]">
                        <b-col sm="3">
                          <label for="sousCategorie">Sous-catégorie :</label>
                        </b-col>
                        <b-col sm="4">
                          <b-form-select
                            :id="`sousCategorieSelect-${rubrique.id}`"
                            :plain="true"
                            :options="sousCategoriesOptions"
                            :value="rubrique.sous_categorie_id"
                            :class="{hasError: errors.sous_categorie_id !== ''}"
                            disabled>
                            <template #first>
                              <b-form-select-option :value="null">--- Sélectionnez une sous-catégorie ---</b-form-select-option>
                            </template>
                          </b-form-select>
                          <span class='field-error'>{{ errors.sous_categorie_id }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label >Couleur de l'arrière plan :</label>
                        </b-col>
                        <b-col sm="4">
                          <div class="colorPreview" :style="getStyle(rubrique)"></div>
                        </b-col>
                      </b-row>
                    </p>
                    <p :id="`editRubrique-${rubrique.id}`" class="card-text d-none">
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label for="libelle">Libellé :</label>
                        </b-col>
                        <b-col sm="4">
                          <b-form-input id="libelle" v-model="libelle" size="sm" placeholder="Entrer le nom de la rubrique" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                          <span class='field-error'>{{ errors.libelle }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label for="categorie">Catégorie :</label>
                        </b-col>
                        <b-col sm="4">
                          <b-form-select
                            :id="`categorieSelect-${rubrique.id}`"
                            :plain="true"
                            :options="categoryOptions"
                            v-model="selectedCategory"
                            :class="{hasError: errors.categorie_id !== ''}">
                            <template #first>
                              <b-form-select-option :value="null">--- Sélectionnez une catégorie ---</b-form-select-option>
                            </template>
                          </b-form-select>
                          <span class='field-error'>{{ errors.categorie_id }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="my-1" v-if="showSousCategory">
                        <b-col sm="3">
                          <label for="sousCategorie">Sous-catégorie :</label>
                        </b-col>
                        <b-col sm="4">
                          <b-form-select
                            :id="`sousCategorieSelect-${rubrique.id}`"
                            :plain="true"
                            :options="sousCategoriesOptions"
                            v-model="selectedSousCategory"
                            :class="{hasError: errors.sous_categorie_id !== ''}">
                            <template #first>
                              <b-form-select-option :value="null">--- Sélectionnez une sous-catégorie ---</b-form-select-option>
                            </template>
                          </b-form-select>
                          <span class='field-error'>{{ errors.sous_categorie_id }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label >Couleur de l'arrière plan :</label>
                        </b-col>
                        <b-col sm="4">
                          <div :id="'colorPreview'+rubrique.id" class="colorPreview" :style="getStyle(rubrique)"></div>
                        </b-col>
                        <b-col sm="4">
                          <chrome-picker :id="'chromePicker'+rubrique.id" v-model="colors" @input="updateValue(rubrique.id)" v-show="showColorPicker[rubrique.id]"/>
                          <img @click="colorPicker(rubrique.id)" class="colorPicker" :id="'colorPicker'+rubrique.id" src="@/assets/images/color_picker_icon_30.png">
                        </b-col>
                        <b-col sm="12">
                          <button type="button" @click="save()" class="btn btn-primary  pull-right">Valider</button>
                          <button type="button" @click="cancelEditRubrique(rubrique.id)" class="btn btn-light pull-right mr-2">Annuler</button>
                        </b-col>
                      </b-row>
                    </p>
                  </b-card>
                </b-collapse>
              </div>
            </SlickList >
          </VuePerfectScrollbar>
        </b-card>
      </b-col>
    </b-row>

    <modal-rubrique :categoryOptions="categoryOptions"></modal-rubrique>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import { SlickList } from 'vue-slicksort';
import handleSlickItem from '@/components/SlickCollapseItem';
import modalRubrique from './ModalRubrique';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import {Chrome} from 'vue-color';
import {isEmpty} from "@/utils/fileHelper";
import {espaceBibliothequeRules as rules, hasRule} from '@/utils/rulesHelper';


export default {
  components: {
    SlickList,
    handleSlickItem,
    'chrome-picker': Chrome,
    VuePerfectScrollbar,
    modalRubrique
  },
  data() {
    return {
      isEmpty,
      showColorPicker: [],
      libelle: '',
      libelle_technique: '',
      rubriqueId: '',
      couleur: '',
      rubriques: [],
      selectedCategory: null,
      selectedSousCategory: null,
      categoryOptions: [],
      sousCategoriesOptions: [],
      showSousCategory: false,
      editSousCategory : [],
      colors: {
        hex: '#fcd5b5',
        // hsl: {h: 27, s: 0.92, l: 0.85, a: 1},
        // hsv: {h: 27, s: 0.92, v: 0.85, a: 1},
        // rgba: {r: 252, g: 213, b: 181, a: 1},
        // a: 1
      },
      ordre: '',
      visible: false,
      errors: {
        libelle: '',
        categorie_id: '',
        sous_categorie_id: ''
      }
    }
  },
  created() {
    this.getRubriques();
    this.getCategories();

    this.$event.on('refresh-rubrique-document', () => {
      this.getRubriques();
    });
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    }
  },
  watch: {
    selectedCategory() {
      if (this.selectedCategory) {
        if (this.selectedCategory === 2) {
          this.showSousCategory = true
          this.getSousCategories()
        } else {
          this.showSousCategory = false
        }
      }
    }
  },
  methods: {
    scrollHandle (evt) {
      // console.log(evt)
    },
    createRubrique() {
      this.$bvModal.show('modal-rubrique');
    },
    sorted(event, newIndex, oldIndex, collection) {
      let self = this;
      let dataPost = {
        'provider': getProvider(),
        'rubriques': this.rubriques
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/espaceBibliotheque/rubriques/sort', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    getRubriques() {
      this.$store.commit("IS_LOADING", true);
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/rubriques')
        .then(response => {
          this.rubriques = response.data.rubriques;
          // Mise en place des variables d'affichage du colorPicker.
          for (let rubrique of response.data.rubriques) {
            this.showColorPicker[rubrique.id] = false;
            if (rubrique.categorie_id == 2) {
              this.editSousCategory[rubrique.id] = true
              this.selectedCategory = rubrique.categorie_id
            } else {
              this.editSousCategory[rubrique.id] = false
            }
          }
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des rubriques. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
    },
    getCategories() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/categories')
        .then(response => {
          this.allCategories = response.data.categories;
          for (let row of response.data.categories) {
            this.categoryOptions.push({text: row.libelle, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          console.log(error)
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des catégories de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
    getSousCategories() {
      return new Promise((resolve, reject) => {
        this.sousCategoriesOptions = [];
        // get sous-categorie where categorie_id = this.selectedCategory
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/sous-categories/' + this.selectedCategory)
          .then(response => {
            this.allSousCategories = response.data.sousCategories;
            // this.dataToTransmit.allSousCategories = response.data.sousCategories;
            for (let row of response.data.sousCategories) {
              this.sousCategoriesOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des sous-catégories de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
      });
    },
    save() {
      if (this.validateData()) {
        let self = this;
        let dataPost = {};
        dataPost.libelle = this.libelle;
        dataPost.couleur = this.colors.hex;
        dataPost.rubriqueId = this.rubriqueId;
        dataPost.categorieId = this.selectedCategory;
        dataPost.sousCategorieId = this.selectedSousCategory;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceBibliotheque/rubrique", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Modification avec succès",
              text: "La rubrique a bien été modifiée",
              showConfirmButton: false,
              timer: 5000
            });

            this.toggleEditRubrique(this.rubriqueId, 'cancel');
            this.getRubriques();
            this.resetInput();
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text:
                "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    clearErrors() {
      this.errors.libelle = '';
      this.errors.categorie_id = '';
      this.errors.sous_categorie_id = '';
    },
    validateData() {
      this.clearErrors();
      let valid = true;
      if (isEmpty(this.libelle)) {
        this.errors.libelle = 'Le libellé est obligatoire';
        valid = false;
      }
      if (isEmpty(this.selectedCategory)) {
        this.errors.categorie_id = "La catégorie est obligatoire";
        valid = false;
      }
      if (this.selectedCategory == 2) {
        if (isEmpty(this.selectedSousCategory)) {
          this.errors.sous_categorie_id = "La sous-catégorie est obligatoire";
          valid = false;
        }
      }
      return valid;
    },
    toggleEditRubrique(rubriqueId, action) {
      let itemToShow
      let itemToHide

      if (action === 'cancel') {
        itemToShow = document.getElementById('infosRubrique-'+rubriqueId)
        itemToHide = document.getElementById('editRubrique-'+rubriqueId)
      } else if (action === 'edit') {
        itemToHide = document.getElementById('infosRubrique-'+rubriqueId)
        itemToShow = document.getElementById('editRubrique-'+rubriqueId)
      }

      itemToHide.classList.remove("d-block")
      itemToHide.classList.add("d-none")
      itemToShow.classList.remove("d-none")
      itemToShow.classList.add("d-block")
    },
    editRubrique(rubrique) {
      this.resetInput();
      this.libelle = rubrique.libelle;
      this.colors.hex = rubrique.couleur;
      this.rubriqueId = rubrique.id;
      if (rubrique.categorie_id != null) {
        this.selectedCategory = rubrique.categorie_id;
      } else {
        this.selectedCategory = null;
      }
      if (rubrique.sous_categorie_id != null) {
        this.selectedSousCategory = rubrique.sous_categorie_id;
      } else {
        this.selectedSousCategory = null;
      }

      if (rubrique.categorie_id == 2) {
        this.showSousCategory = true
      } else {
        this.showSousCategory = false
      }

      this.toggleEditRubrique(rubrique.id, 'edit')
    },
    toggleOnRemoveItem(rubriqueId, isConfirmed) {
      let itemToHide = document.getElementById('item-' + rubriqueId)
      // quand on clique sur l'item (pas sur l'icon supprimer)
      if (itemToHide.classList.contains('active')) {
        itemToHide.classList.remove("active")
      } else {
        if (isConfirmed == false) {
          // quand on clique sur l'icon supprimer sans ouvrir l'item, on le referme directement
          this.$root.$emit('bv::toggle::collapse', 'collapse-' + rubriqueId)
        }
      }
    },
    removeRubrique(rubriqueId) {
      this.toggleOnRemoveItem(rubriqueId, false)
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette rubrique ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!isEmpty(result.dismiss) && result.dismiss === 'cancel') {
            this.toggleOnRemoveItem(rubriqueId, true)
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .delete("/espaceBibliotheque/rubrique/delete/"+rubriqueId)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title: 'Suppression avec succès', text: 'La rubrique a bien été supprimée', showConfirmButton: false, timer: 5000 })
              this.getRubriques()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false);
              let text = 'Une erreur est survenue pendant la suppression de la rubrique, si le problème persiste merci de contacter le support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = error.response.data.message;
              }
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
            })
          }
        })
    },
    cancelEditRubrique(rubriqueId) {
      this.resetInput();
      this.$set(this.showColorPicker, rubriqueId, false);
      this.toggleEditRubrique(rubriqueId, 'cancel')
    },
    resetInput() {
      this.libelle = '';
      this.colors.hex = '';
      this.rubriqueId = '';
      this.selectedCategory = null;
      this.selectedSousCategory = null;
    },
    getStyle(rubrique) {
      return 'background-color: '+rubrique.couleur+'; color: #23282c;';
    },
    canManage() {
      return hasRule(rules.CAN_MANAGE_RUBRIQUE)
    },
    updateValue(rubriqueId) {
      let preview = document.getElementById('colorPreview'+rubriqueId);
      preview.style.backgroundColor = this.colors.hex;
    },
    colorPicker(rubriqueId) {
      this.$set(this.showColorPicker, rubriqueId, !this.showColorPicker[rubriqueId]);
      if (this.showColorPicker[rubriqueId]) {
        let colorWheel = document.getElementById('colorPicker'+rubriqueId);

        let posWheel = colorWheel.getBoundingClientRect();
        let colorPicker = document.getElementById('chromePicker'+rubriqueId);
        let posColorPicker = colorPicker.getBoundingClientRect();
        colorPicker.style.left = '70px';
      }
    },
  }
}
</script>

<style scoped>
  .scroll-area {
    position: absolute;
    height: 60vh;
    width: 90%;
    /*margin: auto;*/
  }
  .color-block {
    display: inline-block;
    width: 4em;
  }
  .colorPreview {
    width: 85%;
    height: 30px;
    border: 1px solid #EEEEEE;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }

  .colorPicker {
    margin-left: 5px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }

  .vc-chrome {
    position: absolute;
    z-index: 1001;
  }
</style>
